import { connectRouter } from 'connected-react-router';
import { reducer as toastr } from "react-redux-toastr";
import { combineReducers } from "redux";
import auth from "./AuthReducer";
import CompanyData from './CompanyDataReducer';
import CompanySettings from './CompanySettingsReducer';
import language from './LanguageReducer';
import SignalRConnection from './SignalRReducer';
import theme from "./themeReducer";
import UserConnectivity from './UserConnectivityReducer';

const createRootReducer = (history: any) => combineReducers({
    router: connectRouter(history),
    theme,
    toastr,
    auth,
    language,
    CompanySettings,
    CompanyData,
    SignalRConnection,
    UserConnectivity,
})

export default createRootReducer;